import React from "react";
import Icone from "./Icone";

/** Pastille « compte concerné » (adresse e-mail, ou adresse masquée du destinataire du code). */
const Compte = ({ email, icone = "utilisateur" }) => (
  <span className="compte">
    <Icone nom={icone} epaisseur={2.2} />
    <span>{email}</span>
  </span>
);

export default Compte;
